import http from '@/components/services/http-common';
import { param } from 'jquery';
import moment from 'moment';

const ROOT_URL = "TimesheetConfirmRequests"
export function get(month) {
  return http.get(`${ROOT_URL}`, {
      params: {
        month: moment(month).format("YYYY-MM-DD")
      }
  }).then(r =>r)
}

export function getPersonal(month) {
  return http.get(`${ROOT_URL}?`, {
      params: {
        month: moment(month).format("YYYY-MM-DD"),
        personal: true
      }
  }).then(r =>r)
}

export function getInfo(id) {
  return http.get(`${ROOT_URL}/info/${id}`).then(r =>r)
}

export function confirm(idArr, confirmedWorktime, confirmNote) {
  if(!idArr) {
    throw "NO ID ARRAY"
  }
  var urlArr = idArr.map(x => {
    console.log(x)
    return http.post(`${ROOT_URL}/confirm/${x.id}`,{
      confirmedWorktime: confirmedWorktime,
      confirmNote: confirmNote
    })
  })
  return Promise.all(urlArr).then( r => r)
}

export function reject(idArr, note) {
  if(!idArr) {
    throw "NO ID ARRAY"
  }
  var urlArr = idArr.map(x => {
    return http.post(`${ROOT_URL}/reject/${x.id}?note=${note}`)
  })
  return Promise.all(urlArr).then( r => r)
}

export function remove(idArr) {
  if(!idArr){
    throw "NO ID ARRAY"
  }
  var urlArr = idArr.map(x => {
    return http.delete(`${ROOT_URL}/${x.id}`)
  })
  return Promise.all(urlArr).then( r => r)
}

export function post(payload) {
  return http.post(`${ROOT_URL}`, payload).then(r =>r)
}